 @if (isLoading()) {
    <div class="flex justify-center items-center fixed inset-0 w-full h-screen z-50 bg-white/50 backdrop-blur-[1px]">
      <div class="w-12 h-12 border-4 border-secondary border-t-transparent rounded-full animate-spin"></div>
    </div>
  } 